import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }

import WOW from 'wowjs'
import { onMounted, ref } from "vue"
import { getProductData } from '@/api/product'
import RichTextRenderer from "@/components/RichTextRenderer.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCom',
  setup(__props) {

const baseUrl = ref(process.env.VUE_APP_BASE_URL)
const platformList = ref([]);
const currentId = ref('')
const content = ref('')
const title = ref('')
const url = new URL(window.location.href);
const params = new URLSearchParams(url.search);
const pro_index = params.get('index');
onMounted(() => {
    new WOW.WOW(
        { live: false }
    ).init()
    getData()
})
const getData = () => {
    getProductData(pro_index).then(res=>{
        // console.log(res);
        content.value = res.data.content
        title.value = res.data.title
        // content.value = content.value.replace(/src="\/media\/uploads\/20/g,`src="${process.env.VUE_APP_BASE_URL}/media/uploads/20`)
        content.value = content.value.replace(
            /src="\/media\//g,
            `src="${process.env.VUE_APP_BASE_URL}/media/`
        );
    })
}
// const returnAll = () => {
//     getTechPlatform().then(res => {
//         console.log(res);
//         platformList.value = res.data
//     })
//     currentId.value = ''

// }

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "cont animate__animated animate__fadeInLeft wow" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(title.value), 1)
        ]),
        _createVNode(RichTextRenderer, { content: content.value }, null, 8, ["content"])
      ])
    ]),
    _: 1
  }))
}
}

})